import {Troop} from "../data/troops/types";
import TravianVersion from "../enum/version";
import {fillPartialFeaturesWithDefaults} from "./TravianVersionHandling";
import {TravianVersionWithPartialFeatures} from "../Version";
import Tribe from "../enum/Tribe";

export type TrainingParameters = {
    buildingLevel: number,
    /** In percent */
    heroBonus: number,
    horseDrinkingTrough: number,
    /** In percent */
    legendsRecruitment: number,
    /** As factor, e.g. 2.0 for double training speed */
    legendsArtefact: number,
    legendsHospital: boolean,
}

const defaultTrainingParameters: TrainingParameters = {
    buildingLevel: 1,
    heroBonus: 0.0,
    horseDrinkingTrough: 0,
    legendsRecruitment: 0.0,
    legendsArtefact: 1.0,
    legendsHospital: false,
};

export function getTrainingTime(
    troop: Troop,
    partialParameters: Partial<TrainingParameters>,
    partialFeatures: TravianVersionWithPartialFeatures,
) {
    const features = fillPartialFeaturesWithDefaults(partialFeatures);
    const parameters: TrainingParameters = {
        ...defaultTrainingParameters,
        ...partialParameters,
    };

    const factors = [
        0.9 ** (parameters.buildingLevel - 1),
        1 / features.features.speed,
    ];

    if (!parameters.legendsHospital || features.version === TravianVersion.Kingdoms) {
        if (troop.id <= 6) {
            // No hero bonus for workshop, residence
            factors.push(1 - parameters.heroBonus);
        }
        if (!troop.isInfantry && troop.tribeId === Tribe.Roman) {
            // No HDT for non-romans, or for infantry
            factors.push(1 - parameters.horseDrinkingTrough / 100);
        }
    }

    if (!parameters.legendsHospital && features.version === TravianVersion.Legends) {
        // No recruitment or artefact for hospital
        factors.push(
            1 - parameters.legendsRecruitment,
            parameters.legendsArtefact,
        )
    }

    if (parameters.legendsHospital && features.version === TravianVersion.Legends) {
        factors.push(0.5);
    }

    const rawTime = troop.trainingTime * factors.reduce((a, b) => a * b, 1);

    if (features.version === TravianVersion.Legends) {
        return rawTime;
    } else {
        return Math.ceil(rawTime);
    }
}
